import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {LanguageHelper} from '../../LanguageHelper';

@Component({
    selector: 'app-products-kaivuri',
    templateUrl: './products-kaivuri.component.html',
    styleUrls: ['./products-kaivuri.component.css']
})
export class ProductsKaivuriComponent implements OnInit {

    title = 'Escavators - Hitec';
    H217Brochure;
    H310Brochure;
    H410Brochure;
    H500fBrochure;
    H510Brochure;

    constructor(private titleService: Title, private languageHelper: LanguageHelper) {
        titleService.setTitle(this.title);
        origin = window.location.origin;

    }

    ngOnInit(): void {
    }

}
